import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'
import * as Sentry from '@sentry/react'
import { errors } from '@/i18n/errors'

export function useFileUpload() {
	return useMutation({
		mutationKey: ['storage-file-upload'],
		mutationFn: async ({ url, file }: { url: string; file: File }) => {
			const response = await fetch(url, {
				method: 'PUT',
				body: file,
			})
			if (response.status >= 400) {
				throw Error(`Error Uploading File: ${response.status}, ${response.text()}`)
			}
		},
		onError: (error, { file }) => {
			toast(errors.FILE_UPLOAD_ISSUE, {
				dismissible: true,
				action: {
					label: 'Ok',
					onClick: () => {},
				},
				duration: 5 * 1000,
			})
			Sentry.captureException(error, {
				tags: {
					type: 'api-call',
					id: 'file-upload',
					fileSize: file.size,
					fileType: file.type,
				},
			})
		},
	})
}
